import { render, staticRenderFns } from "./CtcConfigurationView.vue?vue&type=template&id=52fab826&scoped=true&"
import script from "./CtcConfigurationView.vue?vue&type=script&lang=js&"
export * from "./CtcConfigurationView.vue?vue&type=script&lang=js&"
import style0 from "./CtcConfigurationView.vue?vue&type=style&index=0&id=52fab826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fab826",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VDataTable})
